import { Checkbox } from "@/components/ui/checkbox";

interface FormCheckboxProps {
  id: string;
  label: string;
  checkboxProps?: React.ComponentProps<typeof Checkbox>;
}

export const FormCheckbox = ({
  id,
  label,
  checkboxProps,
}: FormCheckboxProps) => {
  return (
    <div className="text-body-adaptive flex items-center space-x-2">
      <Checkbox className="dark:bg-gray-500" id={id} {...checkboxProps} />
      <label
        htmlFor={id}
        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        {label}
      </label>
    </div>
  );
};
